import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-voice",
  templateUrl: "./med-icon-voice.component.html",
})
export class MedIconVoiceComponent extends SvgMixinComponent {}
